import * as Shape from './shape';
var pkg = require('../package.json');
export var version = pkg.version;
export { Event } from '@antv/g-base';
export { default as Canvas } from './canvas';
export { default as Group } from './group';
export { Shape };
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_g-svg@0.4.7@@antv/g-svg/esm/index.js
// module id = null
// module chunks = 